var _defs, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.988%",
    y1: "13.231%",
    x2: "15.086%",
    y2: "82.791%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D22D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8AF1F",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 3,
    fill: "url(#a)",
    cx: 35.5,
    cy: 35.5,
    r: 35.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 49.318c.84 0 1.53.645 1.603 1.464l.007.146v4.697a1.61 1.61 0 0 1-3.213.146l-.007-.146v-4.697c0-.888.72-1.61 1.61-1.61zm-9.772-4.046c.59.591.626 1.53.104 2.163l-.104.115-3.32 3.319a1.61 1.61 0 0 1-2.381-2.162l.104-.115 3.32-3.32a1.61 1.61 0 0 1 2.277 0zm21.706-.103.115.104 3.32 3.32a1.609 1.609 0 0 1-2.162 2.38l-.115-.104-3.32-3.32a1.611 1.611 0 0 1 2.162-2.38zM35.5 24.029c6.325 0 11.47 5.146 11.47 11.471S41.826 46.971 35.5 46.971c-6.325 0-11.47-5.146-11.47-11.471s5.145-11.471 11.47-11.471zm1.317 3.567-5.269 9.12h2.635v6.688l5.269-9.12h-2.635v-6.688zm18.808 6.294a1.61 1.61 0 0 1 .146 3.213l-.146.007h-4.696a1.61 1.61 0 0 1-.146-3.213l.146-.007h4.696zm-35.554 0a1.61 1.61 0 0 1 .147 3.213l-.147.007h-4.696a1.61 1.61 0 0 1-.146-3.213l.146-.007h4.696zm30.796-13.759c.591.591.627 1.53.105 2.162l-.105.115-3.32 3.32a1.61 1.61 0 0 1-2.38-2.162l.104-.115 3.32-3.32a1.609 1.609 0 0 1 2.276 0zm-28.574-.105.114.104 3.32 3.32a1.61 1.61 0 0 1-2.16 2.383l-.116-.105-3.32-3.321a1.61 1.61 0 0 1 2.162-2.38zm13.207-6.26c.84 0 1.53.643 1.603 1.463l.007.146v4.696a1.61 1.61 0 0 1-3.213.146l-.007-.146v-4.696c0-.888.72-1.61 1.61-1.61z",
    fill: "#FFF",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarIcon);
export default __webpack_public_path__ + "static/media/solar-icon.8be270b1e27616227fd1b1b52a9972c2.svg";
export { ForwardRef as ReactComponent };